import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import img from './home.jpg';
import logo from './logo.png';
import modelImg from './pookalam_girl_transparent.png';
import { 
  Star, 
  Shield, 
  Users, 
  MapPin, 
  Phone, 
  Mail, 
  Clock, 
  Check, 
  Sparkles, 
  // Play, 
  ExternalLink, 
  Map, 
  Award, 
  ShieldCheck, 
  ArrowRight, 
  Loader2,
  Factory,
  Store,
  Truck,
  Coins,
  CheckCircle2,
  BadgeCheck,
  X,
  ZoomIn,
  Eye,
  MessageCircle,
  // Heart,
  Gem
} from 'lucide-react';
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../Auth/firebase";

export default function Home() {
  const navigate = useNavigate();

  // const handleJoinScheme = () => {
  //   navigate('/schemes');
  // };

  const stats = [
    { number: "1500+", label: "Happy Customers" },
    { number: "3000+", label: "Jewellery Pieces Sold" },
    { number: "500+", label: "Custom Creations" },
    { number: "10+", label: "Years of Excellence" }
  ];

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    console.log('Form submitted:', formData);
    // Handle form submission here
  };

  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      quote: "As a housewife, I appreciate the trustworthiness of Chirayil Jewellery. Their gold purity is unmatched and their designs are perfect for traditional occasions.",
      name: "Lakshmi Menon",
      title: "Homemaker",
      rating: 5
    },
    {
      quote: "I've been buying from Chirayil for all family functions - from my daughter's christening to her wedding. Their jewellery becomes family heirlooms.",
      name: "Sarada Pillai",
      title: "Housewife",
      rating: 5
    },
    {
      quote: "The monthly gold schemes helped me save for my daughter's marriage. Now we're using the same jewellery for her trousseau. Very emotional moment for our family.",
      name: "Devika Nambiar",
      title: "Homemaker",
      rating: 5
    },
    {
      quote: "Their service is so patient - they understand that buying gold is a big decision for housewives like me. Never pressured, only good advice.",
      name: "Karthyayani Iyer",
      title: "Housewife",
      rating: 5
    },
    {
      quote: "Even with my limited budget, they helped me find beautiful pieces for daily wear that make me feel special. The staff treats me like family.",
      name: "Parvathy Unni",
      title: "Homemaker",
      rating: 5
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const renderStars = (rating) => {
    return Array(rating).fill(0).map((_, i) => (
      <Star key={i} className="w-4 h-4 text-gold-400 fill-gold-400 inline" />
    ));
  };

  const [activeTab, setActiveTab] = useState('Rings');
  const [selectedOrnament, setSelectedOrnament] = useState(null);

  const tabs = ['Rings', 'Chains', 'Bangles', 'Earrings', 'Lockets', 'Necklaces'];

  const jewelryData = {
    Rings: [
      {
        id: 1,
        name: 'Classic Wedding Bands',
        image: 'https://i.pinimg.com/736x/45/00/79/45007944623b36c5c95cad33d1855812.jpg',
        description: 'Timeless 22K gold wedding bands crafted with comfort-fit interiors and enduring polish.',
        purity: 'BIS 916 Hallmarked Gold',
        weight: '6.5g - 10g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Wholesale & Retail',
        features: ['100% BIS 916 certified purity', 'Comfort-fit contoured band design', 'Manufacturer-direct wholesale value']
      },
      {
        id: 2,
        name: 'Solitaire Gold Band',
        image: 'https://i.pinimg.com/736x/10/2c/80/102c8010a1e0c11ce38577d4085716aa.jpg',
        description: 'Delicate solitaire setting featuring a brilliantly cut diamond set in pure hallmarked yellow gold.',
        purity: 'GIA Diamond • 916 Gold',
        weight: '4.2g - 6g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Bespoke Craft',
        features: ['GIA certified conflict-free diamond', 'Precision 4-prong claw mounting', 'Lifetime exchange guarantee']
      },
      {
        id: 3,
        name: 'Luxury Ring Set',
        image: 'https://i.pinimg.com/736x/40/7e/f5/407ef549011de2003564c19712cb3bb1.jpg',
        description: 'Premium diamond and gold interlocking ring collection designed for bridal elegance.',
        purity: 'BIS 916 • VS1 Diamonds',
        weight: '12g - 16g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Bridal Exclusive',
        features: ['Hand-matched diamond pavé setting', 'Custom sizing by Vaikom goldsmiths', 'Zero middleman making markup']
      },
      {
        id: 4,
        name: 'Filigree Gold Ring',
        image: 'https://i.pinimg.com/736x/a2/29/2a/a2292ad6e26b6f5bc3f6ed309107aa28.jpg',
        description: 'Intricate traditional Kerala temple filigree details hand-worked by artisan masters.',
        purity: 'BIS 916 Hallmarked Gold',
        weight: '8.0g - 11g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Heritage Design',
        features: ['Traditional Kerala antique finish', 'Intricate openwork wire engraving', 'Direct wholesale showroom pricing']
      },
      {
        id: 5,
        name: 'Royal Heritage Band',
        image: 'https://i.pinimg.com/736x/0d/1e/d8/0d1ed8b65414a4457fc25e925404db1f.jpg',
        description: 'Ornate heavyweight gold band inspired by historic Wayanad and Kerala royal motifs.',
        purity: 'BIS 916 Hallmarked Gold',
        weight: '10g - 14g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Royal Edition',
        features: ['Deep relief heirloom engraving', 'Solid 22-karat yellow gold casting', 'Audited purity certificate']
      },
      {
        id: 6,
        name: 'Floral Gold Cluster',
        image: 'https://i.pinimg.com/736x/48/c0/bb/48c0bb487ef916ee6dc4bcd0649e0f62.jpg',
        description: 'Stunning floral gold cluster design bringing together organic beauty and sparkling diamond accents.',
        purity: 'GIA Diamond • 916 Gold',
        weight: '5.5g - 8.5g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Contemporary',
        features: ['Multi-petal floral diamond cluster', 'High-polish rhodium & gold contrast', 'Manufacturer direct savings']
      }
    ],
    Chains: [
      {
        id: 1,
        name: 'Gold Chain Necklace',
        image: 'https://i.pinimg.com/736x/1a/11/6d/1a116d29570b7fc57bf0c8ba5d2cd910.jpg',
        description: 'Classic handcrafted Kerala gold chain designed for daily wear and ceremonial durability.',
        purity: 'BIS 916 Hallmarked Gold',
        weight: '16g - 24g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Daily Wear',
        features: ['High-tensile interlocking links', '100% BIS 916 hallmarked purity', 'Wholesale weight-based rate']
      },
      {
        id: 2,
        name: 'Silver Link Chain',
        image: 'https://i.pinimg.com/736x/67/be/f4/67bef49919c6eeba36e97ff6d8789715.jpg',
        description: 'Contemporary sterling link chain crafted with mirror-polish finish and secure clasp.',
        purity: '925 Sterling • Platinum Plated',
        weight: '20g - 30g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Modern Craft',
        features: ['Tarnish-resistant platinum plating', 'Heavy-gauge curb link structure', 'Custom lengths available']
      },
      {
        id: 3,
        name: 'Delicate Chain Set',
        image: 'https://i.pinimg.com/736x/57/95/4d/57954d18507b7154ddf0e143732bab51.jpg',
        description: 'Fine jewellery chain collection ideal for pairing with traditional lockets and pendants.',
        purity: 'BIS 916 Hallmarked Gold',
        weight: '8g - 12g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Lightweight',
        features: ['Diamond-cut shimmering edges', 'Flex-resistant weave structure', 'Ideal for pendants & daily use']
      },
      {
        id: 4,
        name: 'Ornate Neck Chain',
        image: 'https://i.pinimg.com/736x/c3/07/2d/c3072de8f21c4debc5369772ba0bde7d.jpg',
        description: 'Intricately linked heavy gold chain showcasing master Vaikom goldsmith weaving techniques.',
        purity: 'BIS 916 Hallmarked Gold',
        weight: '28g - 40g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Bridal Heavy',
        features: ['Hand-woven traditional Kerala chain', 'Reinforced safety S-hook clasp', 'Zero middleman markup']
      }
    ],
    Bangles: [
      {
        id: 1,
        name: 'Gold Bangle Set',
        image: 'https://i.pinimg.com/736x/21/ec/76/21ec76ffc24d5c89bb47edff32091e66.jpg',
        description: 'Traditional Kerala gold bangles engraved with auspicious temple symbols and heirloom patterns.',
        purity: 'BIS 916 Hallmarked Gold',
        weight: '24g - 36g (Pair)',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Kerala Temple',
        features: ['Hand-carved traditional motifs', 'Seamless solid gold construction', 'Wholesale manufacturer pricing']
      },
      {
        id: 2,
        name: 'Diamond Bracelet',
        image: 'https://i.pinimg.com/736x/85/68/dc/8568dc5e779072b92295d0c7f868540c.jpg',
        description: 'Sparkling diamond bracelet featuring brilliant-cut stones set in 18K rose and yellow gold.',
        purity: '18K Gold • GIA Diamonds',
        weight: '14g - 18g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Luxury Gala',
        features: ['Flexible articulation for comfort', 'Secure double-lock safety clasp', 'Certified GIA diamond clarity']
      },
      {
        id: 3,
        name: 'Designer Bangles',
        image: 'https://i.pinimg.com/736x/b8/f4/c9/b8f4c9b9051bb81b126e1461c62b9f7f.jpg',
        description: 'Contemporary geometric and floral fusion bangles for modern bridal trousseaux.',
        purity: 'BIS 916 Hallmarked Gold',
        weight: '20g - 30g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Contemporary',
        features: ['Matte & high-polish contrast', 'Custom sizing in showroom', 'Direct factory-wholesale rate']
      }
    ],
    Earrings: [
      {
        id: 1,
        name: 'Diamond Studs',
        image: 'https://i.pinimg.com/736x/93/b3/c9/93b3c980892e7c43f87958d223a17b5f.jpg',
        description: 'Classic solitaire diamond stud earrings providing everyday brilliance and secure screw-backs.',
        purity: 'GIA Certified • 18K Gold',
        weight: '3.5g - 5g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Timeless',
        features: ['VS clarity natural diamonds', 'Comfort screw-back safety posts', 'Wholesale diamond pricing']
      },
      {
        id: 2,
        name: 'Gold Hoops',
        image: 'https://i.pinimg.com/736x/30/35/73/3035735105a751d2536cf128b3f37b90.jpg',
        description: 'Elegant gold hoop earrings crafted with lightweight hollow-tube strength and brilliant polish.',
        purity: 'BIS 916 Hallmarked Gold',
        weight: '6g - 9g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Daily Wear',
        features: ['Lightweight everyday comfort', 'Seamless snap-bar closure', '100% BIS 916 gold guarantee']
      },
      {
        id: 3,
        name: 'Pearl Drops',
        image: 'https://i.pinimg.com/736x/86/e3/b4/86e3b47e2a3bbfde6dc4e20b3f5a28f8.jpg',
        description: 'Sophisticated cultured pearl drop earrings paired with filigree yellow gold caps.',
        purity: 'BIS 916 • Natural Pearls',
        weight: '7g - 10g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Heirloom',
        features: ['Lustrous South Sea style pearls', 'Handcrafted filigree cap work', 'Direct from maker value']
      }
    ],
    Lockets: [
      {
        id: 1,
        name: 'Heart Locket',
        image: 'https://i.pinimg.com/736x/4c/6f/28/4c6f285911f46dc22bafa2a8f35fba22.jpg',
        description: 'Romantic heart-shaped gold locket with intricate diamond-cut surface engraving.',
        purity: 'BIS 916 Hallmarked Gold',
        weight: '5g - 8g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Gifting Choice',
        features: ['Hinged compartment for keepsake', 'Hand-cut reflective pattern', 'Wholesale showroom pricing']
      },
      {
        id: 2,
        name: 'Vintage Locket',
        image: 'https://i.pinimg.com/736x/df/3d/a6/df3da629a05f0460718296683e1424a8.jpg',
        description: 'Antique-inspired locket design showcasing traditional Wayanad floral relief work.',
        purity: 'BIS 916 Hallmarked Gold',
        weight: '8g - 12g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Antique Finish',
        features: ['Deep relief antique texturing', 'Sturdy bail for heavy chains', 'Audited 916 purity certificate']
      }
    ],
    Necklaces: [
      {
        id: 1,
        name: 'Pearl Necklace',
        image: 'https://i.pinimg.com/736x/26/7f/32/267f329aa56dca0e7d6d33caa3b963a2.jpg',
        description: 'Classic pearl strand necklace accentuated with a solid 22K gold temple centerpiece.',
        purity: 'BIS 916 • Cultured Pearls',
        weight: '18g - 25g (Gold weight)',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Bridal Classic',
        features: ['Hand-knotted silk cord strand', 'Intricate 916 gold temple pendant', 'Zero middleman making charge']
      },
      {
        id: 2,
        name: 'Diamond Tennis',
        image: 'https://i.pinimg.com/736x/b3/1a/9b/b31a9b1a8748e68f89830bb95cb87d4f.jpg',
        description: 'Sparkling diamond tennis necklace featuring continuous brilliant-cut diamonds in white gold.',
        purity: 'GIA Diamonds • 18K Gold',
        weight: '22g - 30g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Red Carpet',
        features: ['Individually articulated settings', 'GIA certified diamond clarity', 'Wholesale diamond pricing']
      },
      {
        id: 3,
        name: 'Statement Piece',
        image: 'https://i.pinimg.com/736x/d4/c7/37/d4c73700748c27cb7569163792f5bb5c.jpg',
        description: 'Bold Kerala bridal statement necklace showcasing majestic traditional Lakshmi & floral motifs.',
        purity: 'BIS 916 Hallmarked Gold',
        weight: '45g - 65g',
        origin: 'Vaikom Manufacturing Unit',
        tag: 'Royal Bridal',
        features: ['Master Vaikom artisan carving', 'Adjustable braided back cord', 'Factory-direct wholesale rate']
      }
    ]
  };

  // State for scroll parallax and UI logic
  const [scrollY, setScrollY] = useState(0);
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(null);
  const [showMap, setShowMap] = useState(false);

  useEffect(() => {
    // Scroll tracking
    let ticking = false;
    const handleScroll = () => {
      setScrollY(window.scrollY);
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    // Firebase Auth state listener
    const unsubscribeAuth = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
    });

    return () => {
      window.removeEventListener('scroll', onScroll);
      unsubscribeAuth();
    };
  }, []);

  // Handle scheme selection & Firestore lookup
  const handleSchemeSelect = async (schemeKey) => {
    if (!user) {
      navigate("/login");
      return;
    }

    setChecking(schemeKey);
    try {
      const paymentDocRef = doc(db, `${schemeKey}_payments`, user.uid);
      const requestDocRef = doc(db, `${schemeKey}_request`, user.uid);

      const [paymentSnap, requestSnap] = await Promise.all([
        getDoc(paymentDocRef),
        getDoc(requestDocRef),
      ]);

      if (paymentSnap.exists() || requestSnap.exists()) {
        navigate(`/passbook?scheme=${schemeKey}`);
      } else {
        navigate(`/register?scheme=${schemeKey}`);
      }
    } catch (error) {
      console.error("Error checking scheme registration status:", error);
      navigate(`/register?scheme=${schemeKey}`);
    } finally {
      setChecking(null);
    }
  };

  const scheme1Details = [
    "Flexible monthly payments",
    "No making charges up to 18%",
    "Pure 916 BIS Hallmarked Gold",
    "Start from just ₹1,000",
  ];

  const scheme2Details = [
    "Gold rate lock facility",
    "Pay monthly installments",
    "Redeem as exquisite ornaments",
    "Wastage and making charges discount",
  ];

  return (
    <div className="bg-[#fafaf7] text-[#0b3a24] overflow-hidden relative z-10 font-sans">
      
      {/* Floating Gold Parallax Background Elements */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden select-none z-0">
        {/* Element 1: Traditional Gold Ornament Outline */}
        <div 
          className="absolute left-[3%] top-[10%] w-36 h-36 border border-gold-300/40 rounded-full flex items-center justify-center transition-transform duration-75 ease-out"
          style={{ transform: `translateY(${scrollY * 0.15}px) rotate(${scrollY * 0.05}deg)` }}
        >
          <div className="w-[85%] h-[85%] border border-dashed border-gold-400/25 rounded-full"></div>
        </div>

        {/* Element 2: Traditional Gold Sparkle */}
        <div 
          className="absolute right-[5%] top-[20%] transition-transform duration-75 ease-out"
          style={{ transform: `translateY(${scrollY * -0.1}px) rotate(${scrollY * -0.12}deg)` }}
        >
          <Sparkles className="w-12 h-12 text-[#c5a85a]/40 drop-shadow-[0_0_10px_rgba(197,168,90,0.3)] animate-pulse" />
        </div>

        {/* Element 3: Gold Metallic Pedestal Orb */}
        <div 
          className="absolute left-[6%] top-[36%] w-20 h-20 rounded-full bg-gradient-to-br from-gold-100 via-gold-400/20 to-gold-600/10 blur-[1px] shadow-[inset_0_2px_4px_rgba(255,255,255,0.7),0_8px_32px_rgba(197,168,90,0.15)] transition-transform duration-75 ease-out"
          style={{ transform: `translateY(${scrollY * 0.2}px)` }}
        ></div>

        {/* Element 4: Floating Rings */}
        <div 
          className="absolute right-[8%] top-[50%] w-28 h-28 transition-transform duration-75 ease-out"
          style={{ transform: `translateY(${scrollY * -0.15}px) rotate(${scrollY * 0.08}deg)` }}
        >
          <div className="absolute inset-0 border border-gold-300/35 rounded-full"></div>
          <div className="absolute inset-2 border border-gold-400/20 rounded-full translate-x-2 translate-y-1"></div>
        </div>

        {/* Element 5: Star Sparkle */}
        <div 
          className="absolute left-[4%] top-[68%] transition-transform duration-75 ease-out"
          style={{ transform: `translateY(${scrollY * 0.12}px) rotate(${scrollY * 0.18}deg)` }}
        >
          <Star className="w-8 h-8 fill-[#c5a85a]/20 text-[#c5a85a]/45 drop-shadow-[0_0_8px_rgba(197,168,90,0.25)]" />
        </div>
      </div>

      {/* Hero Section (Kerala Heritage Redesign - Redesigned as Dark Green & Black Gradient Background with model.png on the right-bottom) */}
      <section className="min-h-screen bg-gradient-to-br from-[#041a0f] via-[#09100d] to-[#020906] flex items-center pt-28 pb-12 relative z-10 overflow-hidden text-white">
        
        {/* Animated Blinking Stars in Landing Page */}
        <div className="absolute top-16 right-[18%] pointer-events-none z-10 animate-pulse">
          <Sparkles className="w-10 h-10 text-[#eddca6]/70 drop-shadow-[0_0_15px_rgba(237,220,166,0.6)]" />
        </div>
        <div className="absolute top-32 left-[4%] pointer-events-none z-10 animate-pulse">
          <Star className="w-8 h-8 text-[#eddca6]/50 fill-[#eddca6]/30 drop-shadow-[0_0_10px_rgba(237,220,166,0.5)]" />
        </div>
        <div className="absolute bottom-28 left-[40%] pointer-events-none z-10 animate-pulse">
          <Sparkles className="w-8 h-8 text-[#eddca6]/60 drop-shadow-[0_0_12px_rgba(237,220,166,0.5)]" />
        </div>

        {/* Soft Ambient Light Glow Blobs */}
        <div className="absolute top-[20%] left-1/3 -translate-x-1/2 w-[600px] h-[600px] bg-gradient-to-tr from-gold-900/10 to-transparent rounded-full filter blur-[150px] pointer-events-none -z-10"></div>
        <div className="absolute bottom-[10%] right-[10%] w-[350px] h-[350px] bg-[#eddca6]/10 rounded-full filter blur-[100px] pointer-events-none -z-10"></div>

        {/* Absolute Model Image (Transparent Cutout of Malayali Girl placing complete Onam Pookalam) */}
        <div className="absolute right-0 bottom-0 w-full lg:w-[48%] max-w-[580px] h-[65vh] lg:h-[90vh] z-10 flex items-end justify-end pointer-events-none">
          {/* Ambient gold/green light glow behind the model & Pookalam */}
          <div className="absolute right-1/4 bottom-1/4 w-[380px] h-[380px] bg-[#eddca6]/15 rounded-full filter blur-3xl opacity-75 pointer-events-none"></div>
          <div className="absolute right-10 bottom-10 w-[300px] h-[300px] bg-[#0b3a24]/60 rounded-full filter blur-2xl opacity-90 pointer-events-none"></div>

          <img 
            src={modelImg} 
            alt="Malayali Girl placing complete Onam Pookalam - Chirayil Gold" 
            className="h-full w-auto object-contain object-right-bottom pointer-events-auto filter drop-shadow-[-25px_15px_35px_rgba(0,0,0,0.9)] transform hover:scale-[1.02] transition-transform duration-700 select-none z-10"
            style={{
              WebkitMaskImage: 'linear-gradient(to top, black 92%, transparent 100%), linear-gradient(to right, transparent 0%, black 10%)',
              WebkitMaskComposite: 'source-in',
              maskComposite: 'intersect'
            }}
          />
        </div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-20 w-full h-full flex flex-col justify-between py-12 min-h-[calc(100vh-7rem)]">
          <div className="grid lg:grid-cols-12 gap-12 items-center my-auto w-full">
            
            {/* Left Column (Text details, logo details, and "CHIRAYIL" text placed prominently above "Since 1985") */}
            <div className="lg:col-span-7 space-y-6 text-left pb-12 z-20">
              <div className="space-y-3.5">
                <h1 className="text-white font-serif text-5xl sm:text-6xl lg:text-7.5xl font-black tracking-widest uppercase leading-none drop-shadow-lg">
                  CHIRAYIL
                </h1>
                <div className="text-[#eddca6] font-serif text-2xl sm:text-3xl font-bold tracking-wider">
                  Since 1985
                </div>
                <div className="pt-1">
                  <div className="inline-flex items-center gap-2.5 bg-gradient-to-r from-[#eddca6]/20 via-[#eddca6]/10 to-transparent border border-[#eddca6]/40 px-4 py-2 rounded-full backdrop-blur-md shadow-[0_0_20px_rgba(237,220,166,0.15)]">
                    <Award className="w-4 h-4 text-[#eddca6] shrink-0" />
                    <span className="text-[#eddca6] text-xs sm:text-sm font-bold tracking-wider uppercase font-sans">
                      A Unit from Vaikom Manufacturer • Wholesale and Retail
                    </span>
                  </div>
                </div>
                <div className="text-white/70 text-[9px] tracking-[0.3em] uppercase font-bold font-sans pt-1">
                  Crafting Kerala's Golden Heritage
                </div>
              </div>

              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-medium text-white leading-tight">
                Layered in Traditional <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#eddca6] via-[#f5edd2] to-[#c5a85a] font-black italic">
                  Elegance & Trust
                </span>
              </h2>

              <p className="text-xs sm:text-sm text-white/80 leading-relaxed font-light max-w-xl">
                Welcome to Chirayil Gold & Diamonds in Pulpally — A unit from Vaikom Manufacturer (Wholesale and Retail). We specialize in authentic Kerala ornaments, hand-finished bridal sets, and guaranteed 916 purity.
              </p>

              {/* Attractive Animated Investment Scheme & Business Model CTA Buttons */}
              <div className="pt-2 flex flex-wrap items-center gap-4">
                <button 
                  onClick={() => {
                    const el = document.getElementById('savings-scheme');
                    el?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="gold-shine-btn bg-gradient-to-r from-[#eddca6] via-[#fff3d1] to-[#eddca6] text-[#041a0f] font-sans font-extrabold text-xs uppercase tracking-widest px-8 py-4 rounded-xl shadow-xl hover:scale-105 active:scale-98 transition-all duration-300 flex items-center gap-3 group"
                >
                  <Sparkles className="w-4 h-4 text-[#041a0f] animate-spin-slow" />
                  <span>Join Gold Savings Scheme</span>
                  <ArrowRight className="w-4 h-4 text-[#041a0f] group-hover:translate-x-1.5 transition-transform duration-300" />
                </button>

                <button 
                  onClick={() => {
                    const el = document.getElementById('business-model');
                    el?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="bg-white/10 hover:bg-white/20 text-[#eddca6] hover:text-white border border-[#eddca6]/40 font-sans font-bold text-xs uppercase tracking-widest px-6 py-4 rounded-xl shadow-lg hover:scale-105 active:scale-98 transition-all duration-300 flex items-center gap-2 group backdrop-blur-sm"
                >
                  <Award className="w-4 h-4 text-[#eddca6]" />
                  <span>Wholesale • Making • Retail</span>
                </button>
              </div>

              {/* Secondary CTA indicators (Play / video overview option) & Sub-featured Card Content commented out as requested */}
              {/* 
              <div className="pt-4 flex items-center gap-4">
                <button 
                  onClick={() => {
                    const el = document.getElementById('savings-scheme');
                    el?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-12 h-12 bg-white/10 hover:bg-[#eddca6] text-white hover:text-[#0b3a24] rounded-full flex items-center justify-center transition-all duration-300 border border-[#eddca6]/30 shadow-lg hover:scale-105 active:scale-95 group"
                >
                  <Play className="w-4 h-4 fill-current ml-0.5 group-hover:scale-110 transition-transform" />
                </button>
                <div className="text-left">
                  <span className="block text-[10px] uppercase tracking-widest text-[#eddca6] font-bold">Watch Video</span>
                  <span className="block text-[11px] text-white/60 font-light font-sans">Explore Pulpally Showroom</span>
                </div>
              </div>

              <div className="pt-6 border-t border-white/10 flex items-start gap-5 max-w-xl">
                <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0 border border-[#eddca6]/20 shadow-md">
                  <img 
                    src="https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?q=80&w=300" 
                    alt="Traditional Kerala gold ornament preview" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="space-y-1">
                  <h4 className="text-xs font-bold text-[#eddca6] uppercase tracking-wider">Time to make somebody happy</h4>
                  <p className="text-[11px] text-white/70 font-light leading-relaxed">
                    Make your loved ones feel special with customized bridal sets and traditional gold jewelry.
                  </p>
                  <button 
                    onClick={() => {
                      const el = document.getElementById('collections');
                      el?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-[10px] text-[#eddca6] hover:text-white font-semibold flex items-center gap-1 mt-1 transition-colors font-sans"
                  >
                    <span>View Collection</span>
                    <span>→</span>
                  </button>
                </div>
              </div>
              */}
            </div>

            {/* Right Column Spacer (Desktop only) - to ensure left text elements don't overlap model.png */}
            <div className="hidden lg:block lg:col-span-5 h-[10px] pointer-events-none"></div>

          </div>
        </div>

      </section>

      {/* SPECIAL FEATURE SECTION: Wholesale • Making • Retail (Direct from Vaikom Manufacturer) */}
      <section id="business-model" className="bg-gradient-to-b from-[#fafaf7] via-white to-[#fafaf7] py-28 sm:py-36 px-4 sm:px-6 lg:px-8 border-b border-gold-300 relative z-10 overflow-hidden scroll-mt-20">
        {/* Ambient Gold Bloom Glows */}
        <div className="absolute top-0 right-1/4 w-[500px] h-[500px] bg-gradient-to-bl from-[#eddca6]/25 to-transparent rounded-full filter blur-[130px] pointer-events-none"></div>
        <div className="absolute bottom-0 left-10 w-[400px] h-[400px] bg-[#c5a85a]/15 rounded-full filter blur-[100px] pointer-events-none"></div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Section Header */}
          <div className="text-center max-w-3xl mx-auto space-y-6 mb-20">
            <div className="inline-flex items-center gap-2.5 bg-[#0b3a24] text-[#eddca6] border border-[#eddca6]/40 px-5 py-2 rounded-full text-xs font-bold uppercase tracking-widest shadow-lg">
              <Award className="w-4 h-4 text-[#eddca6] shrink-0" />
              <span>A Unit From Vaikom Manufacturer</span>
            </div>

            <h2 className="text-3xl sm:text-5xl lg:text-6xl font-serif font-black text-[#0b3a24] tracking-tight leading-tight">
              Our Core Business Model: <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0b3a24] via-[#c5a85a] to-[#0b3a24] italic font-serif">
                Wholesale, Making & Retail
              </span>
            </h2>

            <div className="w-24 h-1 bg-gradient-to-r from-transparent via-[#c5a85a] to-transparent mx-auto"></div>

            <p className="text-sm sm:text-base lg:text-lg text-[#0b3a24]/85 leading-relaxed font-light">
              We are primarily a <strong className="font-semibold text-[#0b3a24]">large-scale wholesale distributor and custom jewellery making house</strong> originating from Vaikom—Kerala's celebrated cradle of gold craftsmanship. Because we manufacture and supply at wholesale volume without middlemen, we proudly open our doors to <strong className="font-semibold text-[#0b3a24]">retail customers</strong> with manufacturer-direct transparency, unbeatable savings, and guaranteed BIS 916 purity.
            </p>
          </div>

          {/* Three Core Pillar Cards (Wholesale, Making, Retail) */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10 mb-16">
            
            {/* Pillar 1: Wholesale Supply (Main Focus) */}
            <div className="bg-white rounded-3xl p-8 sm:p-10 border-2 border-gold-300/70 hover:border-[#0b3a24] shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2.5 flex flex-col justify-between group relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#eddca6]/15 rounded-bl-full pointer-events-none group-hover:scale-125 transition-transform duration-700"></div>
              
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#0b3a24] to-[#0e4e30] rounded-2xl flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300 border border-[#eddca6]/40">
                    <Truck className="w-6 h-6 text-[#eddca6]" />
                  </div>
                  <span className="bg-[#0b3a24]/10 text-[#0b3a24] text-[10px] font-extrabold uppercase tracking-widest px-3 py-1 rounded-full font-sans">
                    Core Business
                  </span>
                </div>

                <div className="space-y-2">
                  <span className="text-[11px] uppercase tracking-widest font-bold text-[#c5a85a] font-sans block">Primary Pillar</span>
                  <h3 className="text-2xl sm:text-3xl font-serif font-black text-[#0b3a24] group-hover:text-[#c5a85a] transition-colors">
                    Wholesale Supply
                  </h3>
                </div>

                <p className="text-xs sm:text-sm text-[#0b3a24]/80 leading-relaxed font-light">
                  We are mainly a wholesale distributor supplying BIS 916 hallmarked gold and certified diamond ornaments in bulk to showrooms and jewellery merchants across Kerala. Our high-volume operations ensure unmatched pricing, strict auditing, and dependable supply chain excellence.
                </p>

                <div className="pt-4 border-t border-gold-200 space-y-2.5">
                  <div className="flex items-center gap-2.5 text-xs text-[#0b3a24] font-medium font-sans">
                    <CheckCircle2 className="w-4 h-4 text-[#0c6b43] shrink-0" />
                    <span>Bulk showroom & merchant orders</span>
                  </div>
                  <div className="flex items-center gap-2.5 text-xs text-[#0b3a24] font-medium font-sans">
                    <CheckCircle2 className="w-4 h-4 text-[#0c6b43] shrink-0" />
                    <span>Unbeatable wholesale market rates</span>
                  </div>
                  <div className="flex items-center gap-2.5 text-xs text-[#0b3a24] font-medium font-sans">
                    <CheckCircle2 className="w-4 h-4 text-[#0c6b43] shrink-0" />
                    <span>100% BIS 916 certified purity guarantee</span>
                  </div>
                </div>
              </div>

              <div className="w-10 h-1 bg-[#0b3a24]/20 group-hover:bg-[#0b3a24] transition-colors mt-8"></div>
            </div>

            {/* Pillar 2: In-House Making & Manufacturing (Vaikom Heritage) */}
            <div className="bg-gradient-to-br from-[#0b3a24] via-[#0e482d] to-[#072517] text-white rounded-3xl p-8 sm:p-10 border-2 border-[#eddca6] shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2.5 flex flex-col justify-between group relative overflow-hidden">
              <div className="absolute -top-10 -right-10 w-44 h-44 bg-[#eddca6]/10 rounded-full blur-2xl pointer-events-none"></div>
              
              <div className="space-y-6 relative z-10">
                <div className="flex items-center justify-between">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#eddca6] to-[#c5a85a] rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <Factory className="w-6 h-6 text-[#0b3a24]" />
                  </div>
                  <span className="bg-[#eddca6] text-[#0b3a24] text-[10px] font-extrabold uppercase tracking-widest px-3.5 py-1 rounded-full font-sans shadow-sm">
                    Vaikom Roots
                  </span>
                </div>

                <div className="space-y-2">
                  <span className="text-[11px] uppercase tracking-widest font-bold text-[#eddca6] font-sans block">Craftsmanship Unit</span>
                  <h3 className="text-2xl sm:text-3xl font-serif font-black text-white group-hover:text-[#eddca6] transition-colors">
                    Ornament Making
                  </h3>
                </div>

                <p className="text-xs sm:text-sm text-white/90 leading-relaxed font-light">
                  Jewellery making is in our blood. Originating as a manufacturing house from Vaikom—historically celebrated as Kerala's gold artisans' hub—our master goldsmiths cast, hand-engrave, and finish traditional temple sets and bespoke bridal trousseaux in-house with surgical precision.
                </p>

                <div className="pt-4 border-t border-white/20 space-y-2.5">
                  <div className="flex items-center gap-2.5 text-xs text-white/95 font-medium font-sans">
                    <BadgeCheck className="w-4 h-4 text-[#eddca6] shrink-0" />
                    <span>Traditional Vaikom master goldsmiths</span>
                  </div>
                  <div className="flex items-center gap-2.5 text-xs text-white/95 font-medium font-sans">
                    <BadgeCheck className="w-4 h-4 text-[#eddca6] shrink-0" />
                    <span>Custom bridal & temple trousseau making</span>
                  </div>
                  <div className="flex items-center gap-2.5 text-xs text-white/95 font-medium font-sans">
                    <BadgeCheck className="w-4 h-4 text-[#eddca6] shrink-0" />
                    <span>Zero middleman or third-party making charges</span>
                  </div>
                </div>
              </div>

              <div className="w-10 h-1 bg-[#eddca6]/40 group-hover:bg-[#eddca6] transition-colors mt-8"></div>
            </div>

            {/* Pillar 3: Direct Retail Showroom (Direct to Family) */}
            <div className="bg-white rounded-3xl p-8 sm:p-10 border-2 border-gold-300/70 hover:border-[#0b3a24] shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2.5 flex flex-col justify-between group relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#eddca6]/15 rounded-bl-full pointer-events-none group-hover:scale-125 transition-transform duration-700"></div>
              
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#0b3a24] to-[#0e4e30] rounded-2xl flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300 border border-[#eddca6]/40">
                    <Store className="w-6 h-6 text-[#eddca6]" />
                  </div>
                  <span className="bg-[#0b3a24]/10 text-[#0b3a24] text-[10px] font-extrabold uppercase tracking-widest px-3 py-1 rounded-full font-sans">
                    Pulpally Store
                  </span>
                </div>

                <div className="space-y-2">
                  <span className="text-[11px] uppercase tracking-widest font-bold text-[#c5a85a] font-sans block">Direct to Family</span>
                  <h3 className="text-2xl sm:text-3xl font-serif font-black text-[#0b3a24] group-hover:text-[#c5a85a] transition-colors">
                    Retail Showroom
                  </h3>
                </div>

                <p className="text-xs sm:text-sm text-[#0b3a24]/80 leading-relaxed font-light">
                  While our backbone is wholesale and making, our Pulpally showroom opens our doors directly to retail families. Whether purchasing a single ring or an entire wedding trousseau, you buy at factory-direct pricing with warm hospitality and lifetime service support.
                </p>

                <div className="pt-4 border-t border-gold-200 space-y-2.5">
                  <div className="flex items-center gap-2.5 text-xs text-[#0b3a24] font-medium font-sans">
                    <CheckCircle2 className="w-4 h-4 text-[#0c6b43] shrink-0" />
                    <span>Manufacturer-direct retail value</span>
                  </div>
                  <div className="flex items-center gap-2.5 text-xs text-[#0b3a24] font-medium font-sans">
                    <CheckCircle2 className="w-4 h-4 text-[#0c6b43] shrink-0" />
                    <span>Purchase single ornaments at wholesale pricing</span>
                  </div>
                  <div className="flex items-center gap-2.5 text-xs text-[#0b3a24] font-medium font-sans">
                    <CheckCircle2 className="w-4 h-4 text-[#0c6b43] shrink-0" />
                    <span>Personalized bridal trousseau consultations</span>
                  </div>
                </div>
              </div>

              <div className="w-10 h-1 bg-[#0b3a24]/20 group-hover:bg-[#0b3a24] transition-colors mt-8"></div>
            </div>

          </div>

          {/* Interactive Advantage Highlight Box: Why Buy Direct from a Vaikom Manufacturer? */}
          <div className="bg-gradient-to-r from-[#041a0f] via-[#0b3a24] to-[#041a0f] rounded-3xl p-8 sm:p-12 text-white border border-[#eddca6]/40 shadow-2xl relative overflow-hidden">
            <div className="absolute right-0 bottom-0 w-80 h-80 bg-[#eddca6]/10 rounded-full blur-3xl pointer-events-none"></div>

            <div className="grid lg:grid-cols-12 gap-8 items-center relative z-10">
              
              <div className="lg:col-span-6 space-y-4 text-left">
                <div className="inline-flex items-center gap-2 text-[#eddca6] text-xs font-bold uppercase tracking-widest">
                  <Coins className="w-4 h-4" />
                  <span>The Chirayil Price & Purity Advantage</span>
                </div>
                <h3 className="text-2xl sm:text-4xl font-serif font-black text-white leading-tight">
                  Why Buying Direct From Our Manufacturer Unit Makes All The Difference
                </h3>
                <p className="text-xs sm:text-sm text-white/80 leading-relaxed font-light">
                  Traditional retail jewelry chains purchase from third-party manufacturers, wholesalers, and distributors—adding layers of markup at every step. Because <strong className="text-[#eddca6] font-medium">Chirayil is a direct manufacturing unit from Vaikom</strong>, you eliminate middleman fees and receive authentic 916 gold with maximum investment value.
                </p>
              </div>

              {/* Comparison Steps */}
              <div className="lg:col-span-6 grid sm:grid-cols-2 gap-4">
                
                {/* Traditional Retail */}
                <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-5 space-y-3">
                  <div className="text-xs font-bold uppercase tracking-wider text-white/70">Traditional Retail Chains</div>
                  <div className="text-sm font-semibold text-white/90 flex items-center gap-2">
                    <span>Factory → Wholesaler → Dealer → You</span>
                  </div>
                  <p className="text-[11px] text-white/70 font-light">
                    Includes multiple distributor markups, added transport costs, and inflated making charges.
                  </p>
                </div>

                {/* Chirayil Advantage */}
                <div className="bg-gradient-to-br from-[#eddca6] to-[#c5a85a] text-[#0b3a24] rounded-2xl p-5 space-y-3 shadow-xl transform sm:scale-105 border-2 border-white/80">
                  <div className="text-xs font-black uppercase tracking-wider text-[#0b3a24]">Chirayil Gold & Diamonds</div>
                  <div className="text-sm font-extrabold text-[#0b3a24] flex items-center gap-2">
                    <span>Vaikom Making Unit ➔ Direct To You</span>
                  </div>
                  <p className="text-[11px] text-[#0b3a24]/90 font-medium">
                    Zero middlemen! Enjoy factory-direct wholesale rates, guaranteed BIS 916 purity, and genuine Kerala craftsmanship.
                  </p>
                </div>

              </div>

            </div>

          </div>

        </div>
      </section>

      {/* Main Section: Exclusive Gold Savings (Promoted Savings Section) */}
      <section id="savings-scheme" className="bg-[#fafaf7] py-28 px-4 sm:px-6 lg:px-8 border-y border-gold-300 relative z-10 scroll-mt-12">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold-300/10 via-transparent to-transparent pointer-events-none"></div>

        {/* Blinking Star Element */}
        <div className="absolute top-12 right-[8%] pointer-events-none z-10 animate-pulse">
          <Star className="w-8 h-8 fill-[#c5a85a]/30 text-[#c5a85a] drop-shadow-[0_0_10px_rgba(197,168,90,0.4)]" />
        </div>
        <div className="absolute bottom-16 left-[5%] pointer-events-none z-10 animate-pulse">
          <Sparkles className="w-9 h-9 text-[#c5a85a]/50 drop-shadow-[0_0_12px_rgba(197,168,90,0.3)]" />
        </div>

        <div className="max-w-5xl mx-auto relative z-10">
          
          {/* Header */}
          <div className="text-center mb-16 space-y-4">
            <div className="inline-flex items-center gap-2 bg-[#0b3a24]/10 border border-[#c5a85a]/30 text-[#0b3a24] px-4 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest shadow-sm">
              <Sparkles className="w-3.5 h-3.5 text-[#0b3a24] animate-pulse" />
              Exclusive Gold Savings
            </div>
            <h2 className="text-4xl sm:text-5xl font-serif font-bold text-[#0b3a24] tracking-tight">
              Choose Your <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0b3a24] via-[#c5a85a] to-[#0b3a24] font-black">Investment Scheme</span>
            </h2>
            <p className="max-w-xl mx-auto text-xs sm:text-sm text-[#0b3a24]/70 font-light leading-relaxed">
              Invest monthly in our gold saving plans and redeem premium ornaments for your daughter's marriage with zero making charges.
            </p>
          </div>

          {/* Schemes Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
            
            {/* Scheme 1 Card */}
            <div 
              onClick={() => !checking && handleSchemeSelect("scheme1")}
              className={`group relative bg-gradient-to-br from-white via-[#fafaf7] to-white border border-gold-300 rounded-3xl p-8 hover:border-[#0b3a24]/40 hover:scale-[1.02] hover:shadow-2xl hover:shadow-gold-500/10 transition-all duration-500 cursor-pointer flex flex-col justify-between overflow-hidden min-h-[420px] shadow-sm ${
                checking === "scheme1" ? "pointer-events-none opacity-80" : ""
              }`}
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold-300 rounded-full blur-3xl opacity-[0.03] group-hover:opacity-[0.07] transition-opacity duration-500 -mr-16 -mt-16"></div>
              
              <div>
                <div className="flex items-center justify-between mb-6">
                  <div className="w-12 h-12 bg-white border border-gold-300 rounded-2xl flex items-center justify-center group-hover:bg-[#0b3a24] group-hover:border-[#0b3a24] transition-colors duration-300">
                    <Award className="w-6 h-6 text-[#0b3a24] group-hover:text-white transition-colors" />
                  </div>
                  <span className="text-[9px] font-bold text-[#0b3a24] bg-[#0b3a24]/10 border border-[#0b3a24]/20 px-3 py-1 rounded-md tracking-widest uppercase font-sans">Plan A</span>
                </div>
                
                <h3 className="text-2xl font-serif font-black text-[#0b3a24] mb-3">Scheme 1</h3>
                <p className="text-[#0b3a24]/80 text-xs sm:text-sm mb-6 leading-relaxed font-light">
                  Protect your savings from market volatility by locking your gold rate now and securing maximum value.
                </p>
                
                <div className="space-y-3.5 border-t border-gold-200 pt-6">
                  {scheme1Details.map((detail, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <ShieldCheck className="w-4 h-4 text-[#0d5c3a] flex-shrink-0 mt-0.5" />
                      <span className="text-[#0b3a24] text-xs sm:text-sm font-medium">{detail}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-gold-200 flex items-center justify-between">
                <span className="text-xs font-semibold tracking-widest uppercase text-[#0b3a24] group-hover:text-[#c5a85a] transition-colors font-sans">
                  {checking === "scheme1" ? "Checking details..." : "Proceed to Scheme"}
                </span>
                <button 
                  className="w-10 h-10 rounded-xl bg-white border border-gold-300 group-hover:bg-[#0b3a24] group-hover:border-[#0b3a24] flex items-center justify-center transition-all duration-300"
                  disabled={checking === "scheme1"}
                >
                  {checking === "scheme1" ? (
                    <Loader2 className="w-4 h-4 text-[#0b3a24] animate-spin" />
                  ) : (
                    <ArrowRight className="w-4 h-4 text-[#0b3a24] group-hover:text-white transition-colors duration-300" />
                  )}
                </button>
              </div>
            </div>

            {/* Scheme 2 Card */}
            <div 
              onClick={() => !checking && handleSchemeSelect("scheme2")}
              className={`group relative bg-gradient-to-br from-white via-[#fafaf7] to-white border border-gold-300 rounded-3xl p-8 hover:border-[#0b3a24]/40 hover:scale-[1.02] hover:shadow-2xl hover:shadow-gold-500/15 transition-all duration-500 cursor-pointer flex flex-col justify-between overflow-hidden min-h-[420px] shadow-sm ${
                checking === "scheme2" ? "pointer-events-none opacity-80" : ""
              }`}
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold-300 rounded-full blur-3xl opacity-[0.03] group-hover:opacity-[0.07] transition-opacity duration-500 -mr-16 -mt-16"></div>
              
              <div>
                <div className="flex items-center justify-between mb-6">
                  <div className="w-12 h-12 bg-white border border-gold-300 rounded-2xl flex items-center justify-center group-hover:bg-[#0b3a24] group-hover:border-[#0b3a24] transition-colors duration-300">
                    <Award className="w-6 h-6 text-[#0b3a24] group-hover:text-white transition-colors" />
                  </div>
                  <span className="text-[9px] font-bold text-[#0b3a24] bg-[#0b3a24]/10 border border-[#0b3a24]/20 px-3 py-1 rounded-md tracking-widest uppercase font-sans">Plan B</span>
                </div>
                
                <h3 className="text-2xl font-serif font-black text-[#0b3a24] mb-3">Scheme 2</h3>
                <p className="text-[#0b3a24]/80 text-xs sm:text-sm mb-6 leading-relaxed font-light">
                  A highly secure and convenient savings plan designed for dynamic investors seeking flexibility and premium returns.
                </p>
                
                <div className="space-y-3.5 border-t border-gold-200 pt-6">
                  {scheme2Details.map((detail, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <ShieldCheck className="w-4 h-4 text-[#0d5c3a] flex-shrink-0 mt-0.5" />
                      <span className="text-[#0b3a24] text-xs sm:text-sm font-medium">{detail}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-gold-200 flex items-center justify-between">
                <span className="text-xs font-semibold tracking-widest uppercase text-[#0b3a24] group-hover:text-[#c5a85a] transition-colors font-sans">
                  {checking === "scheme2" ? "Checking details..." : "Proceed to Scheme"}
                </span>
                <button 
                  className="w-10 h-10 rounded-xl bg-white border border-gold-300 group-hover:bg-[#0b3a24] group-hover:border-[#0b3a24] flex items-center justify-center transition-all duration-300"
                  disabled={checking === "scheme2"}
                >
                  {checking === "scheme2" ? (
                    <Loader2 className="w-4 h-4 text-[#0b3a24] animate-spin" />
                  ) : (
                    <ArrowRight className="w-4 h-4 text-[#0b3a24] group-hover:text-white transition-colors duration-300" />
                  )}
                </button>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Redesigned OUR HERITAGE Section */}
      <section className="bg-white py-28 sm:py-36 px-4 relative z-10 border-b border-gold-200">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-20 items-center">
            
            {/* Left Column: Overlapping Heritage Collage */}
            <div className="relative flex justify-center items-center py-10 lg:py-0">
              {/* Decorative background ring pattern */}
              <div className="absolute w-[360px] sm:w-[450px] h-[360px] sm:h-[450px] border border-gold-200/40 rounded-full pointer-events-none z-0"></div>
              <div className="absolute w-[280px] sm:w-[350px] h-[280px] sm:h-[350px] border border-dashed border-gold-300/30 rounded-full pointer-events-none z-0"></div>

              {/* Main image: Goldsmith master craftsmanship */}
              <div className="relative w-[260px] sm:w-[320px] aspect-[3/4] rounded-3xl overflow-hidden shadow-2xl border border-gold-300 z-10 transform -rotate-2 hover:rotate-0 transition-transform duration-700">
                <img 
                  src="https://images.unsplash.com/photo-1573408301185-9146fe634ad0?q=80&w=800" 
                  alt="Indian goldsmith crafting gold jewelry chains" 
                  className="w-full h-full object-cover filter contrast-[1.05]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#041a0f]/40 to-transparent"></div>
              </div>

              {/* Overlapping secondary image: Traditional logo seal */}
              <div className="absolute right-2 bottom-0 sm:-right-4 w-[150px] sm:w-[180px] aspect-square bg-[#fafaf7] rounded-3xl p-5 border-2 border-[#eddca6] shadow-2xl z-20 transform rotate-6 hover:rotate-0 transition-all duration-700 flex flex-col items-center justify-center text-center group">
                <img 
                  src={logo} 
                  alt="Chirayil Logo Emblem Seal" 
                  className="w-14 h-14 object-contain mb-3 transition-transform group-hover:scale-105" 
                />
                <span className="text-[10px] font-bold text-[#0b3a24] uppercase tracking-widest font-sans">Est. 1985</span>
                <span className="text-[8px] text-gold-600 uppercase tracking-widest mt-0.5 font-sans">Pulpally</span>
              </div>
            </div>

            {/* Right Column: Redesigned Narrative & Values Cards List */}
            <div className="space-y-8 lg:pl-10 z-10">
              <div className="space-y-4">
                <div className="inline-flex items-center gap-2 border border-gold-300 px-4 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest text-[#0b3a24] bg-[#fafaf7] shadow-sm font-sans">
                  <Award className="w-3.5 h-3.5 text-[#0b3a24]" />
                  Legacy of Wayanad
                </div>
                
                <h2 className="text-4xl sm:text-5xl font-serif font-black text-[#0b3a24] leading-tight">
                  Four Decades of <br />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0b3a24] via-[#c5a85a] to-[#0b3a24] italic font-serif">
                    Golden Heritage
                  </span>
                </h2>
                <div className="w-16 h-0.5 bg-[#0b3a24]"></div>
              </div>

              <p className="text-[#0b3a24]/80 text-base sm:text-lg leading-relaxed font-light">
                Since 1985, Chirayil Gold and Diamonds — a unit from Vaikom Manufacturer (Wholesale and Retail) — has been a symbol of trusted craftsmanship in the heart of Pulpally. We believe every piece of gold carries a family's legacy, memories, and hope.
              </p>

              {/* Values List Cards */}
              <div className="space-y-4 pt-2">
                
                {/* Value 1 */}
                <div className="flex gap-4 p-5 rounded-2xl bg-[#fafaf7] border border-gold-250 hover:border-[#0b3a24]/30 hover:shadow-md transition-all duration-300 group">
                  <div className="w-10 h-10 bg-white border border-gold-300 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-[#0b3a24] transition-colors duration-300">
                    <Check className="w-4 h-4 text-[#0d5c3a] group-hover:text-white transition-colors" />
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-[#0b3a24] mb-1 font-sans">Heritage Design Curations</h4>
                    <p className="text-[#0b3a24]/70 text-xs leading-relaxed font-light">
                      Collections inspired by Wayanad's local heritage, blending historical values with contemporary cuts.
                    </p>
                  </div>
                </div>

                {/* Value 2 */}
                <div className="flex gap-4 p-5 rounded-2xl bg-[#fafaf7] border border-gold-250 hover:border-[#0b3a24]/30 hover:shadow-md transition-all duration-300 group">
                  <div className="w-10 h-10 bg-white border border-gold-300 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-[#0b3a24] transition-colors duration-300">
                    <Check className="w-4 h-4 text-[#0d5c3a] group-hover:text-white transition-colors" />
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-[#0b3a24] mb-1 font-sans">BIS Hallmarked Purity</h4>
                    <p className="text-[#0b3a24]/70 text-xs leading-relaxed font-light">
                      Uncompromised purity controls with GIA certifications, standard rates, and authentic hallmarks.
                    </p>
                  </div>
                </div>

                {/* Value 3 */}
                <div className="flex gap-4 p-5 rounded-2xl bg-[#fafaf7] border border-gold-250 hover:border-[#0b3a24]/30 hover:shadow-md transition-all duration-300 group">
                  <div className="w-10 h-10 bg-white border border-gold-300 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-[#0b3a24] transition-colors duration-300">
                    <Check className="w-4 h-4 text-[#0d5c3a] group-hover:text-white transition-colors" />
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-[#0b3a24] mb-1 font-sans">Legacy of Generational Trust</h4>
                    <p className="text-[#0b3a24]/70 text-xs leading-relaxed font-light">
                      A multi-decade legacy of trust, offering bespoke services and master gold craftsmanship.
                    </p>
                  </div>
                </div>

              </div>

              {/* Signature Quote Callout */}
              <div className="p-5 border-l-2 border-[#eddca6] bg-[#fafaf7]/50 rounded-r-2xl italic text-[#0b3a24]/85 text-sm font-serif">
                “At Chirayil, gold is not just an ornament; it is Wayanad's legacy passed down through generations.”
              </div>

              <div className="pt-2">
                <button 
                  onClick={() => {
                    const el = document.getElementById('collections');
                    el?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="bg-[#0b3a24] hover:bg-[#0c482c] text-white border border-transparent font-bold px-10 py-4 rounded-xl text-xs uppercase tracking-widest transition-all duration-300 shadow-md hover:-translate-y-0.5 font-sans"
                >
                  Explore Collections
                </button>
              </div>
            </div>

          </div>
        </div>
      </section>
   
      {/* Why Chirayil Features Section */}
      <section className="bg-[#fafaf7]/50 py-28 px-4 sm:px-6 lg:px-8 relative z-10 border-b border-gold-200">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            
            {/* Branding Sidebar */}
            <div className="lg:col-span-1 bg-gradient-to-br from-[#0b3a24] via-[#0e482d] to-[#072517] rounded-3xl p-8 text-white flex flex-col justify-between min-h-[380px] shadow-xl hover:-translate-y-1.5 transition-all duration-500 group relative overflow-hidden border border-gold-300/30">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 ease-out"></div>
              
              <div className="space-y-5">
                <div className="w-10 h-[2px] bg-gold-400"></div>
                <h2 className="text-3xl font-serif font-black tracking-wide leading-tight text-gold-300">Why Choose Chirayil</h2>
                <p className="text-xs sm:text-sm leading-relaxed text-white/95 font-light">
                  Where heritage craftsmanship meets contemporary elegance. Every piece in our collection represents a legacy of purity, certified excellence, and custom designs created to become precious family heirlooms.
                </p>
              </div>
              <button 
                onClick={() => {
                  const el = document.getElementById('collections');
                  el?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-white/10 backdrop-blur-md border border-white/20 text-white px-5 py-3 rounded-xl hover:bg-white/20 transition-all duration-300 self-start flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest shadow-inner mt-4 font-sans"
              >
                View Collection
                <span className="text-sm transition-transform group-hover:translate-x-1">→</span>
              </button>
            </div>

            {/* Feature Cards (Ivory Glassmorphism) */}
            <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-8">
              
              {/* Exclusive Design */}
              <div className="bg-white/60 backdrop-blur-sm border border-gold-300/40 rounded-3xl p-8 flex flex-col justify-between min-h-[380px] shadow-sm hover:shadow-xl hover:border-[#0b3a24]/25 transition-all duration-500 hover:-translate-y-2 group">
                <div className="space-y-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-gold-300 to-[#c5a85a] rounded-2xl flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300">
                    <Star className="w-5 h-5 text-white" />
                  </div>
                  <h3 className="text-2xl font-serif font-black text-[#0b3a24] group-hover:text-[#c5a85a] transition-colors">Exclusive Design</h3>
                  <p className="text-xs sm:text-sm leading-relaxed text-[#0b3a24]/80 font-light">
                    Explore curated, limited-edition collections crafted to reflect both traditional styles and contemporary aesthetics.
                  </p>
                </div>
                <div className="w-8 h-1 bg-[#0b3a24]/20 group-hover:bg-[#0b3a24] transition-colors mt-6"></div>
              </div>

              {/* Certified Purity */}
              <div className="bg-white/60 backdrop-blur-sm border border-gold-300/40 rounded-3xl p-8 flex flex-col justify-between min-h-[380px] shadow-sm hover:shadow-xl hover:border-[#0b3a24]/25 transition-all duration-500 hover:-translate-y-2 group">
                <div className="space-y-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-gold-300 to-[#c5a85a] rounded-2xl flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300">
                    <Shield className="w-5 h-5 text-white" />
                  </div>
                  <h3 className="text-2xl font-serif font-black text-[#0b3a24] group-hover:text-[#c5a85a] transition-colors">Guaranteed Purity</h3>
                  <p className="text-xs sm:text-sm leading-relaxed text-[#0b3a24]/80 font-light">
                    Every gram is audited and BIS hallmarked. All diamonds are GIA certified with comprehensive quality guarantees.
                  </p>
                </div>
                <div className="w-8 h-1 bg-[#0b3a24]/20 group-hover:bg-[#0b3a24] transition-colors mt-6"></div>
              </div>

              {/* Bespoke Customization */}
              <div className="bg-white/60 backdrop-blur-sm border border-gold-300/40 rounded-3xl p-8 flex flex-col justify-between min-h-[380px] shadow-sm hover:shadow-xl hover:border-[#0b3a24]/25 transition-all duration-500 hover:-translate-y-2 group">
                <div className="space-y-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-gold-300 to-[#c5a85a] rounded-2xl flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300">
                    <Users className="w-5 h-5 text-white" />
                  </div>
                  <h3 className="text-2xl font-serif font-black text-[#0b3a24] group-hover:text-[#c5a85a] transition-colors">Custom Creations</h3>
                  <p className="text-xs sm:text-sm leading-relaxed text-[#0b3a24]/80 font-light">
                    Collaborate directly with our master designers to craft custom necklaces, rings, and personalized bridal sets.
                  </p>
                </div>
                <div className="w-8 h-1 bg-[#0b3a24]/20 group-hover:bg-[#0b3a24] transition-colors mt-6"></div>
              </div>

            </div>
          </div>
        </div>
      </section>
 
      {/* Stats Counter Overlay Section */}
      <section className="relative w-full h-80 overflow-hidden flex items-center border-b border-gold-250 z-10">
        <img 
          src="https://media.istockphoto.com/id/1277517088/photo/fancy-designer-antique-golden-bracelets-for-woman-fashion.jpg?s=612x612&w=0&k=20&c=n49O0S5rIgzxJX5bU1YjwRHfou0DYPcmsv-N5JAAM14="
          alt="Jewelry Background" 
          className="absolute inset-0 w-full h-full object-cover filter brightness-50 contrast-125"
          style={{ transform: `scale(1.1) translateY(${scrollY * 0.04}px)` }}
        />
        
        {/* Soft Gold/Cream Parallax Overlay */}
        <div className="absolute inset-0 bg-[#fafaf7]/95 backdrop-blur-[3px]"></div>
        
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-12 text-center divide-x divide-gold-300">
            {stats.map((stat, index) => (
              <div key={index} className="space-y-2 md:px-4">
                <div className="text-5xl md:text-6xl font-serif font-black text-[#0b3a24] drop-shadow-sm tracking-tight">
                  {stat.number}
                </div>
                <div className="text-xs font-bold tracking-[0.2em] text-[#0b3a24]/60 uppercase font-sans">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* NEW MODEL: Jewels of Elegance Showcase & Inspection Gallery */}
      <section id="collections" className="bg-gradient-to-b from-white via-[#fafaf7] to-white py-28 px-4 sm:px-6 lg:px-8 relative z-10 border-b border-gold-200 scroll-mt-16 overflow-hidden">
        
        {/* Decorative Luxury Glow & Shimmer Elements */}
        <div className="absolute top-14 left-[7%] pointer-events-none z-10 animate-pulse">
          <Sparkles className="w-10 h-10 text-[#c5a85a]/60 drop-shadow-[0_0_12px_rgba(197,168,90,0.4)]" />
        </div>
        <div className="absolute top-24 right-[8%] pointer-events-none z-10 animate-pulse">
          <Star className="w-8 h-8 fill-[#c5a85a]/30 text-[#c5a85a]/70 drop-shadow-[0_0_10px_rgba(197,168,90,0.4)]" />
        </div>
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-gradient-to-r from-[#c5a85a]/10 via-[#0b3a24]/10 to-transparent blur-3xl rounded-full pointer-events-none"></div>

        <div className="max-w-7xl mx-auto relative z-20">
          
          {/* Header Area */}
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
            <div className="inline-flex items-center gap-2 bg-[#0b3a24] text-[#eddca6] px-4 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-[0.25em] shadow-sm">
              <Gem className="w-3.5 h-3.5 text-[#eddca6]" />
              <span>MUSEUM-GRADE VAIKOM CRAFTSMANSHIP</span>
            </div>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-black text-[#0b3a24] tracking-tight">
              Jewels of <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0b3a24] via-[#c5a85a] to-[#0b3a24] font-black italic">Elegance</span>
            </h2>
            <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-[#0b3a24]/40 to-transparent mx-auto"></div>
            <p className="text-sm sm:text-base text-[#0b3a24]/80 font-light leading-relaxed">
              Explore our master-crafted gold and diamond ornaments. Every piece is 100% BIS 916 hallmarked or GIA certified, available to retail families at wholesale manufacturer pricing. Click any jewel for a high-resolution inspection.
            </p>
          </div>

          {/* Navigation Category Tabs with Count Badges */}
          <div className="flex flex-wrap justify-center gap-2.5 sm:gap-3 mb-16">
            {tabs.map((tab) => {
              const count = jewelryData[tab]?.length || 0;
              const isActive = activeTab === tab;
              return (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`group px-6 py-3.5 font-bold text-xs uppercase tracking-widest transition-all duration-300 rounded-2xl border flex items-center gap-2.5 ${
                    isActive
                      ? 'bg-gradient-to-r from-[#0b3a24] via-[#0e482d] to-[#0b3a24] border-[#c5a85a] text-white shadow-xl scale-105 font-sans'
                      : 'text-[#0b3a24] bg-white border-gold-300/80 hover:border-[#0b3a24] hover:bg-[#fafaf7] hover:shadow-md font-sans'
                  }`}
                >
                  <span>{tab}</span>
                  <span className={`text-[10px] px-2 py-0.5 rounded-full font-sans transition-colors ${
                    isActive
                      ? 'bg-[#eddca6] text-[#0b3a24] font-bold'
                      : 'bg-gold-200/60 text-[#0b3a24] group-hover:bg-[#0b3a24] group-hover:text-white'
                  }`}>
                    {count}
                  </span>
                </button>
              );
            })}
          </div>

          {/* SPOTLIGHT HERO SHOWCASE (First item in Active Tab) */}
          {jewelryData[activeTab] && jewelryData[activeTab].length > 0 && (
            <div className="mb-20 bg-gradient-to-br from-[#041a0f] via-[#072a19] to-[#041a0f] rounded-[2.5rem] p-6 sm:p-10 lg:p-12 text-white border-2 border-[#eddca6]/60 shadow-2xl relative overflow-hidden group">
              {/* Subtle background glow */}
              <div className="absolute -right-20 -bottom-20 w-80 h-80 bg-[#c5a85a]/15 rounded-full blur-3xl pointer-events-none"></div>

              <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center relative z-10">
                {/* Spotlight Image Vitrine (Left 7 cols) */}
                <div className="lg:col-span-7 relative">
                  <div className="relative rounded-3xl overflow-hidden border-2 border-[#eddca6]/40 shadow-2xl bg-[#0b3a24]/30 aspect-[16/11] sm:aspect-[16/10] group-hover:border-[#eddca6] transition-all duration-700">
                    <img
                      src={jewelryData[activeTab][0].image}
                      alt={jewelryData[activeTab][0].name}
                      className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                    />
                    {/* Floating Hallmarked Tag */}
                    <div className="absolute top-4 left-4 bg-[#0b3a24]/90 backdrop-blur-md border border-[#eddca6] text-[#eddca6] px-3.5 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest shadow-lg flex items-center gap-1.5">
                      <ShieldCheck className="w-3.5 h-3.5 text-[#c5a85a]" />
                      <span>{jewelryData[activeTab][0].purity || 'BIS 916 Hallmarked Gold'}</span>
                    </div>

                    {/* Floating Zoom Button */}
                    <button
                      onClick={() => setSelectedOrnament(jewelryData[activeTab][0])}
                      className="absolute bottom-4 right-4 bg-white/95 text-[#0b3a24] hover:bg-[#eddca6] px-4 py-2.5 rounded-2xl text-xs font-bold uppercase tracking-wider shadow-lg flex items-center gap-2 transition-all duration-300 hover:scale-105"
                    >
                      <ZoomIn className="w-4 h-4 text-[#0b3a24]" />
                      <span>Inspect High-Res</span>
                    </button>
                  </div>
                </div>

                {/* Spotlight Craftsmanship Specifications (Right 5 cols) */}
                <div className="lg:col-span-5 space-y-6">
                  <div className="inline-flex items-center gap-2 bg-[#eddca6]/15 border border-[#eddca6]/30 text-[#eddca6] px-3.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest">
                    <span>👑 FEATURED MASTERPIECE • {activeTab.toUpperCase()}</span>
                  </div>

                  <h3 className="text-3xl sm:text-4xl font-serif font-black text-white tracking-tight leading-tight">
                    {jewelryData[activeTab][0].name}
                  </h3>

                  <p className="text-xs sm:text-sm text-gray-200 font-light leading-relaxed">
                    {jewelryData[activeTab][0].description}
                  </p>

                  {/* Specification Grid */}
                  <div className="grid grid-cols-2 gap-3 pt-2">
                    <div className="bg-white/5 border border-white/10 rounded-2xl p-3.5">
                      <div className="text-[10px] uppercase tracking-widest text-[#eddca6] font-bold">Gold Weight</div>
                      <div className="text-sm font-semibold text-white mt-0.5">{jewelryData[activeTab][0].weight || '6.5g - 12g'}</div>
                    </div>
                    <div className="bg-white/5 border border-white/10 rounded-2xl p-3.5">
                      <div className="text-[10px] uppercase tracking-widest text-[#eddca6] font-bold">Manufacturing</div>
                      <div className="text-sm font-semibold text-white mt-0.5">{jewelryData[activeTab][0].origin || 'Vaikom Unit'}</div>
                    </div>
                  </div>

                  {/* Key Craftsmanship Points */}
                  <div className="space-y-2 pt-1 border-t border-white/10">
                    {(jewelryData[activeTab][0].features || [
                      '100% BIS 916 certified purity',
                      'Comfort-fit contoured band design',
                      'Manufacturer-direct wholesale value'
                    ]).map((feat, idx) => (
                      <div key={idx} className="flex items-center gap-2.5 text-xs text-white/90 font-light">
                        <Check className="w-3.5 h-3.5 text-[#eddca6] flex-shrink-0" />
                        <span>{feat}</span>
                      </div>
                    ))}
                  </div>

                  {/* Action Buttons */}
                  <div className="flex flex-wrap items-center gap-3 pt-3">
                    <button
                      onClick={() => setSelectedOrnament(jewelryData[activeTab][0])}
                      className="bg-gradient-to-r from-[#eddca6] via-[#c5a85a] to-[#eddca6] text-[#0b3a24] font-black px-6 py-3.5 rounded-xl text-xs uppercase tracking-widest shadow-lg hover:scale-105 active:scale-95 transition-all duration-300 flex items-center gap-2"
                    >
                      <Eye className="w-4 h-4" />
                      <span>Quick Inspect</span>
                    </button>
                    <a
                      href={`https://wa.me/919447012345?text=${encodeURIComponent(`Hello Chirayil Gold & Diamonds, I would like to inquire about the Featured ${jewelryData[activeTab][0].name} in ${activeTab}.`)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-white/10 hover:bg-white/20 text-white border border-white/20 px-6 py-3.5 rounded-xl text-xs font-bold uppercase tracking-widest transition-all duration-300 flex items-center gap-2"
                    >
                      <MessageCircle className="w-4 h-4 text-[#eddca6]" />
                      <span>WhatsApp Price</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Section Divider Subtitle */}
          <div className="text-center mb-12">
            <h3 className="text-xl sm:text-2xl font-serif font-bold text-[#0b3a24]">
              More Exquisite <span className="text-[#c5a85a]">{activeTab}</span> in Our Showcase
            </h3>
            <p className="text-xs text-[#0b3a24]/70 font-light mt-1">
              Select any ornament below to view high-resolution imagery and direct manufacturer details
            </p>
          </div>

          {/* NEW MUSEUM VITRINE CARD GRID (All items in Active Tab) */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {jewelryData[activeTab].map((item) => (
              <div
                key={item.id}
                onClick={() => setSelectedOrnament(item)}
                className="group cursor-pointer bg-white rounded-3xl p-4 sm:p-5 border border-gold-300/80 hover:border-[#0b3a24] shadow-sm hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 flex flex-col justify-between relative overflow-hidden"
              >
                {/* Top decorative badge overlay */}
                <div className="relative aspect-[4/5] rounded-2xl overflow-hidden bg-gradient-to-b from-[#fafaf7] to-[#f2ede1] border border-gold-200/70 mb-5">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
                  />
                  {/* Floating Purity Badge */}
                  <div className="absolute top-3 left-3 bg-[#0b3a24]/90 backdrop-blur-sm text-[#eddca6] px-3 py-1 rounded-full text-[9px] font-bold uppercase tracking-widest shadow-md">
                    {item.purity ? item.purity.split('•')[0].trim() : 'BIS 916'}
                  </div>

                  {/* Floating Tag */}
                  <div className="absolute top-3 right-3 bg-white/95 text-[#0b3a24] border border-gold-300 px-2.5 py-1 rounded-full text-[9px] font-bold uppercase tracking-widest shadow-sm">
                    {item.tag || 'Wholesale'}
                  </div>

                  {/* Hover Quick Inspect Overlay */}
                  <div className="absolute inset-0 bg-[#0b3a24]/40 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <div className="bg-white text-[#0b3a24] px-5 py-2.5 rounded-full text-xs font-bold uppercase tracking-widest shadow-xl flex items-center gap-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                      <ZoomIn className="w-4 h-4 text-[#c5a85a]" />
                      <span>Inspect Jewel ✦</span>
                    </div>
                  </div>
                </div>

                {/* Card Info */}
                <div className="space-y-3">
                  <div className="flex items-start justify-between gap-2">
                    <h4 className="text-xl font-serif font-bold text-[#0b3a24] group-hover:text-[#c5a85a] transition-colors leading-tight">
                      {item.name}
                    </h4>
                  </div>

                  <p className="text-xs text-[#0b3a24]/75 font-light leading-relaxed line-clamp-2">
                    {item.description}
                  </p>

                  {/* Mini specification footer */}
                  <div className="pt-3 border-t border-gold-200 flex items-center justify-between text-[11px] text-[#0b3a24]/80 font-sans">
                    <div>
                      <span className="font-bold text-[#0b3a24]">Weight:</span> {item.weight || '7.5g'}
                    </div>
                    <div className="text-[#0d5c3a] font-bold uppercase tracking-wider flex items-center gap-1">
                      <span>View Details →</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* HIGH-RESOLUTION ORNAMENT INSPECTION LIGHTBOX MODAL */}
          {selectedOrnament && (
            <div 
              className="fixed inset-0 z-50 bg-[#041a0f]/80 backdrop-blur-md flex items-center justify-center p-4 sm:p-6 overflow-y-auto animate-fade-in"
              onClick={() => setSelectedOrnament(null)}
            >
              <div 
                className="max-w-4xl w-full bg-white rounded-[2.5rem] border-2 border-[#eddca6] shadow-2xl overflow-hidden grid grid-cols-1 md:grid-cols-12 relative my-8"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Close Button */}
                <button
                  onClick={() => setSelectedOrnament(null)}
                  className="absolute top-4 right-4 z-20 w-10 h-10 bg-[#0b3a24] text-white hover:bg-red-700 rounded-full flex items-center justify-center shadow-lg transition-colors"
                >
                  <X className="w-5 h-5" />
                </button>

                {/* Left Side: Large High-Resolution Ornament Showcase (6 cols) */}
                <div className="md:col-span-6 bg-gradient-to-b from-[#fafaf7] to-[#e8dfc8] p-6 sm:p-8 flex flex-col justify-between relative border-b md:border-b-0 md:border-r border-gold-300">
                  <div className="flex items-center justify-between mb-4">
                    <div className="bg-[#0b3a24] text-[#eddca6] px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest shadow-sm">
                      {selectedOrnament.purity || 'BIS 916 Hallmarked Gold'}
                    </div>
                    <div className="text-[10px] font-bold text-[#0b3a24] uppercase tracking-wider">
                      {selectedOrnament.tag || 'Wholesale & Retail'}
                    </div>
                  </div>

                  {/* Main High-Res Image Container */}
                  <div className="aspect-square w-full rounded-2xl overflow-hidden border border-gold-300 shadow-xl bg-white relative group">
                    <img
                      src={selectedOrnament.image}
                      alt={selectedOrnament.name}
                      className="w-full h-full object-cover object-center transition-transform duration-700 hover:scale-125 cursor-zoom-in"
                    />
                    <div className="absolute bottom-2 left-2 bg-black/60 backdrop-blur-sm text-white px-2.5 py-1 rounded-md text-[9px] uppercase tracking-wider font-sans pointer-events-none">
                      Hover to zoom image
                    </div>
                  </div>

                  <div className="mt-4 text-center">
                    <span className="text-[11px] text-[#0b3a24]/70 italic font-serif">
                      “Crafted in our Vaikom manufacturing unit with lifetime purity assurance”
                    </span>
                  </div>
                </div>

                {/* Right Side: Detailed Ornament Story & Wholesale Inquiry (6 cols) */}
                <div className="md:col-span-6 p-6 sm:p-8 flex flex-col justify-between space-y-6 bg-white">
                  <div className="space-y-4">
                    <div className="text-xs font-bold text-[#c5a85a] tracking-[0.2em] uppercase">
                      CHIRAYIL DESIGNER SHOWCASE
                    </div>

                    <h3 className="text-3xl font-serif font-black text-[#0b3a24] leading-tight">
                      {selectedOrnament.name}
                    </h3>

                    <p className="text-xs sm:text-sm text-[#0b3a24]/80 leading-relaxed font-light">
                      {selectedOrnament.description}
                    </p>

                    {/* Specifications Grid Table */}
                    <div className="grid grid-cols-2 gap-3 pt-2">
                      <div className="bg-[#fafaf7] p-3 rounded-2xl border border-gold-200">
                        <div className="text-[10px] text-[#0b3a24]/60 uppercase font-bold">Gold Weight Range</div>
                        <div className="text-xs font-bold text-[#0b3a24] mt-0.5">{selectedOrnament.weight || '8.0g - 12.5g'}</div>
                      </div>
                      <div className="bg-[#fafaf7] p-3 rounded-2xl border border-gold-200">
                        <div className="text-[10px] text-[#0b3a24]/60 uppercase font-bold">Origin</div>
                        <div className="text-xs font-bold text-[#0b3a24] mt-0.5">{selectedOrnament.origin || 'Vaikom Maker Unit'}</div>
                      </div>
                      <div className="bg-[#fafaf7] p-3 rounded-2xl border border-gold-200 col-span-2">
                        <div className="text-[10px] text-[#0b3a24]/60 uppercase font-bold">Pricing Advantage</div>
                        <div className="text-xs font-bold text-[#0d5c3a] mt-0.5">Manufacturer-Direct Wholesale & Retail Pricing</div>
                      </div>
                    </div>

                    {/* Features checklist */}
                    <div className="space-y-2 pt-2 border-t border-gold-200">
                      <div className="text-[11px] font-bold text-[#0b3a24] uppercase tracking-wider mb-1">
                        Craftsmanship Guarantees:
                      </div>
                      {(selectedOrnament.features || [
                        '100% BIS 916 hallmarked & certified purity',
                        'Direct from Vaikom manufacturing workshop',
                        'Zero middleman markup for retail families'
                      ]).map((feat, i) => (
                        <div key={i} className="flex items-center gap-2 text-xs text-[#0b3a24]/80 font-light">
                          <CheckCircle2 className="w-4 h-4 text-[#0d5c3a] flex-shrink-0" />
                          <span>{feat}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="space-y-3 pt-4 border-t border-gold-300">
                    <a
                      href={`https://wa.me/919447012345?text=${encodeURIComponent(`Hello Chirayil Gold & Diamonds, I am interested in "${selectedOrnament.name}" (${selectedOrnament.purity}). Please share wholesale/retail pricing and availability.`)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full bg-gradient-to-r from-[#0b3a24] via-[#0e482d] to-[#0b3a24] text-white font-bold py-3.5 px-6 rounded-xl text-xs uppercase tracking-widest shadow-lg hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 flex items-center justify-center gap-2"
                    >
                      <MessageCircle className="w-4 h-4 text-[#eddca6]" />
                      <span>Inquire Wholesale & Retail Price</span>
                    </a>
                    <button
                      onClick={() => setSelectedOrnament(null)}
                      className="w-full bg-[#fafaf7] hover:bg-gold-200/50 text-[#0b3a24] font-bold py-3 px-6 rounded-xl text-xs uppercase tracking-widest border border-gold-300 transition-colors"
                    >
                      Back to Collection
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </section>

      {/* Testimonials Carousel Section */}
      <section className="bg-[#fafaf7]/60 py-28 px-4 sm:px-6 lg:px-8 border-b border-gold-200 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          
          <p className="text-xs font-bold text-[#0b3a24] tracking-[0.25em] uppercase font-sans mb-4">TESTIMONIALS</p>
          <h2 className="text-4xl sm:text-5xl font-serif font-black text-[#0b3a24] mb-16">
            Words From Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0b3a24] to-[#c5a85a] font-black">Valued Customers</span>
          </h2>

          {/* Testimonial Luxury Panel */}
          <div className="relative max-w-3xl mx-auto bg-white/90 backdrop-blur-sm p-10 md:p-14 rounded-3xl border border-gold-300 shadow-xl min-h-[280px] overflow-hidden flex items-center justify-center">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index} 
                className={`w-full flex-shrink-0 absolute transition-all duration-700 ease-in-out px-4 md:px-8 ${
                  index === currentSlide 
                    ? 'opacity-100 translate-x-0 pointer-events-auto scale-100' 
                    : 'opacity-0 translate-x-16 pointer-events-none scale-95'
                }`}
              >
                <div className="space-y-6">
                  <span className="text-[#0b3a24]/30 font-serif text-6xl leading-none block h-6 -mb-4 select-none">“</span>
                  <p className="text-[#0b3a24] text-lg sm:text-xl font-serif italic leading-relaxed font-light">
                    {testimonial.quote}
                  </p>
                  <span className="text-[#0b3a24]/30 font-serif text-6xl leading-none block h-6 -mt-6 text-right select-none">”</span>

                  <div className="pt-4">
                    <h3 className="text-base font-bold text-[#0b3a24]">{testimonial.name}</h3>
                    <p className="text-xs text-[#0b3a24] mt-1 font-semibold uppercase tracking-wider font-sans">{testimonial.title}</p>
                    <div className="flex justify-center gap-1.5 mt-4">
                      {renderStars(testimonial.rating)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Carousel Indicators */}
          <div className="flex justify-center gap-3 mt-10">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full border transition-all duration-300 ${
                  index === currentSlide 
                    ? 'bg-[#0b3a24] border-[#0b3a24] scale-125' 
                    : 'bg-white border-gold-300 hover:bg-gold-100'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

        </div>
      </section>

      {/* Showroom Location Details Section (Redesigned Flagship Showcase) */}
      <section id="showroom" className="bg-gradient-to-b from-white via-[#fafaf7] to-white py-28 px-4 sm:px-6 lg:px-8 border-b border-gold-200 relative z-10 scroll-mt-16 overflow-hidden">
        {/* Blinking Star & Sparkle Elements */}
        <div className="absolute top-12 right-[6%] pointer-events-none z-10 animate-pulse">
          <Star className="w-8 h-8 fill-[#c5a85a]/30 text-[#c5a85a]/70 drop-shadow-[0_0_10px_rgba(197,168,90,0.4)]" />
        </div>
        <div className="absolute bottom-16 left-[5%] pointer-events-none z-10 animate-pulse">
          <Sparkles className="w-9 h-9 text-[#c5a85a]/50 drop-shadow-[0_0_12px_rgba(197,168,90,0.3)]" />
        </div>

        {/* Soft Ambient Background Light */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-gradient-to-tr from-gold-300/10 via-[#0b3a24]/5 to-transparent rounded-full filter blur-[140px] pointer-events-none -z-10"></div>

        <div className="max-w-7xl mx-auto">
          
          {/* Header */}
          <div className="text-center mb-16 space-y-4">
            <div className="inline-flex items-center gap-2 bg-[#0b3a24]/10 border border-[#c5a85a]/30 text-[#0b3a24] px-4 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest shadow-sm font-sans">
              <MapPin className="w-3.5 h-3.5 text-[#0b3a24]" />
              VISIT OUR FLAGSHIP SHOWROOM
            </div>
            <h2 className="text-4xl sm:text-5xl font-serif font-black text-[#0b3a24] tracking-tight">
              Step Into <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0b3a24] via-[#c5a85a] to-[#0b3a24] font-black">Chirayil Pulpally</span>
            </h2>
            <p className="max-w-2xl mx-auto text-xs sm:text-sm text-[#0b3a24]/75 font-light leading-relaxed">
              Experience Kerala’s rich gold artistry in our grand Wayanad showroom. Enjoy private bridal lounge consultations, certified 916 BIS purity testing, and master craftsmanship.
            </p>
            <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-[#0b3a24]/30 to-transparent mx-auto pt-2"></div>
          </div>

          <div className="grid lg:grid-cols-12 gap-10 items-stretch">
            
            {/* Left Column - Store Details & VIP Services */}
            <div className="lg:col-span-7 flex flex-col justify-between space-y-6">
              
              {/* Showroom Details Luxury Card */}
              <div className="p-8 rounded-3xl bg-white border border-gold-300/80 shadow-xl relative overflow-hidden group">
                <div className="absolute top-0 right-0 w-36 h-36 bg-gradient-to-br from-gold-300/20 to-transparent rounded-full blur-2xl pointer-events-none"></div>
                
                <div className="flex items-center justify-between mb-8 pb-6 border-b border-gold-200">
                  <div className="flex items-center gap-3.5">
                    <div className="w-12 h-12 rounded-2xl bg-[#0b3a24] flex items-center justify-center text-white shadow-md">
                      <MapPin className="w-6 h-6 text-[#eddca6]" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-serif font-bold text-[#0b3a24]">Pulpally Flagship</h3>
                      <span className="text-[10px] text-[#0b3a24]/60 uppercase tracking-widest font-sans font-semibold">Wayanad, Kerala</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 bg-[#0b3a24]/10 border border-[#0b3a24]/20 px-3 py-1.5 rounded-full">
                    <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
                    <span className="text-[10px] font-bold text-[#0b3a24] uppercase tracking-wider font-sans">Open Today</span>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-6">
                  {/* Address */}
                  <div className="flex gap-3.5 items-start p-3.5 rounded-2xl bg-[#fafaf7] border border-gold-200/60 hover:border-gold-300 transition-colors">
                    <div className="w-9 h-9 rounded-xl bg-white border border-gold-300 flex items-center justify-center flex-shrink-0 mt-0.5 text-[#0b3a24]">
                      <MapPin className="w-4 h-4" />
                    </div>
                    <div>
                      <span className="block text-[9px] uppercase tracking-wider text-[#0b3a24] font-bold font-sans">Location Address</span>
                      <span className="text-xs text-[#0b3a24]/85 font-medium leading-tight block mt-0.5">PERIKALLUR Road, Pulpally, Wayanad, Kerala - 673579</span>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="flex gap-3.5 items-start p-3.5 rounded-2xl bg-[#fafaf7] border border-gold-200/60 hover:border-gold-300 transition-colors">
                    <div className="w-9 h-9 rounded-xl bg-white border border-gold-300 flex items-center justify-center flex-shrink-0 mt-0.5 text-[#0b3a24]">
                      <Phone className="w-4 h-4" />
                    </div>
                    <div>
                      <span className="block text-[9px] uppercase tracking-wider text-[#0b3a24] font-bold font-sans">Phone Enquiries</span>
                      <a href="tel:+919605155088" className="text-xs text-[#0b3a24]/85 font-medium block hover:text-[#c5a85a] transition-colors mt-0.5 font-sans">
                        +91 9605155088
                      </a>
                      <a href="tel:+916282370250" className="text-xs text-[#0b3a24]/85 font-medium block hover:text-[#c5a85a] transition-colors font-sans">
                        +91 6282370250
                      </a>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="flex gap-3.5 items-start p-3.5 rounded-2xl bg-[#fafaf7] border border-gold-200/60 hover:border-gold-300 transition-colors">
                    <div className="w-9 h-9 rounded-xl bg-white border border-gold-300 flex items-center justify-center flex-shrink-0 mt-0.5 text-[#0b3a24]">
                      <Mail className="w-4 h-4" />
                    </div>
                    <div>
                      <span className="block text-[9px] uppercase tracking-wider text-[#0b3a24] font-bold font-sans">Email Contact</span>
                      <a href="mailto:info@chirayilgoldanddiamonds.com" className="text-xs text-[#0b3a24]/85 font-medium block hover:text-[#c5a85a] transition-colors mt-0.5 font-sans truncate max-w-[180px] sm:max-w-none">
                        info@chirayilgoldanddiamonds.com
                      </a>
                    </div>
                  </div>

                  {/* Hours */}
                  <div className="flex gap-3.5 items-start p-3.5 rounded-2xl bg-[#fafaf7] border border-gold-200/60 hover:border-gold-300 transition-colors">
                    <div className="w-9 h-9 rounded-xl bg-white border border-gold-300 flex items-center justify-center flex-shrink-0 mt-0.5 text-[#0b3a24]">
                      <Clock className="w-4 h-4" />
                    </div>
                    <div>
                      <span className="block text-[9px] uppercase tracking-wider text-[#0b3a24] font-bold font-sans">Working Hours</span>
                      <span className="text-xs text-[#0b3a24]/85 font-medium block mt-0.5">Mon - Sun: 10:00 AM - 08:00 PM</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Showroom Exclusive Amenities Grid */}
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                <div className="p-4 rounded-2xl bg-white border border-gold-200 shadow-sm text-center flex flex-col items-center justify-center space-y-1.5 hover:border-[#0b3a24]/30 transition-all hover:-translate-y-0.5">
                  <Sparkles className="w-5 h-5 text-[#c5a85a]" />
                  <span className="text-xs font-bold text-[#0b3a24] block font-sans">Bridal Lounge</span>
                  <span className="text-[9px] text-[#0b3a24]/60 font-light block">Private consultations</span>
                </div>

                <div className="p-4 rounded-2xl bg-white border border-gold-200 shadow-sm text-center flex flex-col items-center justify-center space-y-1.5 hover:border-[#0b3a24]/30 transition-all hover:-translate-y-0.5">
                  <ShieldCheck className="w-5 h-5 text-[#c5a85a]" />
                  <span className="text-xs font-bold text-[#0b3a24] block font-sans">BIS Karatmeter</span>
                  <span className="text-[9px] text-[#0b3a24]/60 font-light block">Instant purity test</span>
                </div>

                <div className="p-4 rounded-2xl bg-white border border-gold-200 shadow-sm text-center flex flex-col items-center justify-center space-y-1.5 hover:border-[#0b3a24]/30 transition-all hover:-translate-y-0.5">
                  <Award className="w-5 h-5 text-[#c5a85a]" />
                  <span className="text-xs font-bold text-[#0b3a24] block font-sans">Master Goldsmiths</span>
                  <span className="text-[9px] text-[#0b3a24]/60 font-light block">Bespoke jewelry</span>
                </div>

                <div className="p-4 rounded-2xl bg-white border border-gold-200 shadow-sm text-center flex flex-col items-center justify-center space-y-1.5 hover:border-[#0b3a24]/30 transition-all hover:-translate-y-0.5">
                  <Check className="w-5 h-5 text-[#c5a85a]" />
                  <span className="text-xs font-bold text-[#0b3a24] block font-sans">Valet Parking</span>
                  <span className="text-[9px] text-[#0b3a24]/60 font-light block">Complimentary service</span>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 pt-2">
                <a 
                  href="https://www.google.com/maps/place/Chirayil+Gold+%26+Diamonds/@11.856124,76.150303,16z"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gold-shine-btn flex-1 bg-gradient-to-r from-[#0b3a24] via-[#0e482d] to-[#0b3a24] text-white hover:scale-[1.01] active:scale-[0.99] font-bold px-8 py-4 rounded-xl text-xs uppercase tracking-widest transition-all duration-300 shadow-lg flex items-center justify-center gap-2 font-sans"
                >
                  <span>Get Directions on Google Maps</span>
                  <ExternalLink className="w-4 h-4 text-[#eddca6]" />
                </a>

                <button 
                  onClick={() => setShowMap(!showMap)}
                  className="border border-gold-300 text-[#0b3a24] bg-white hover:bg-gold-50 font-bold px-6 py-4 rounded-xl text-xs uppercase tracking-widest transition-all duration-300 shadow-sm flex items-center justify-center gap-2 font-sans"
                >
                  <Map className="w-4 h-4 text-[#0b3a24]" />
                  <span>{showMap ? "Hide Map Drawer" : "Interactive Map Preview"}</span>
                </button>
              </div>

            </div>

            {/* Right Column - Storefront Visual & Map Frame */}
            <div className="lg:col-span-5 flex flex-col justify-between">
              <div className="h-full min-h-[380px] bg-gradient-to-br from-[#fafaf7] to-white border-2 border-[#eddca6] rounded-3xl p-4 shadow-xl flex flex-col justify-between relative overflow-hidden group">
                
                {/* Embedded Map Container or Live View */}
                <div className="w-full h-full min-h-[340px] rounded-2xl overflow-hidden relative border border-gold-300 bg-luxury-cream shadow-inner">
                  <iframe
                    title="Chirayil Gold and Diamonds Google Map View"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d3904.7019517216722!2d76.1503030750581!3d11.85612398836603!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1734508758906!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="w-full h-full object-cover filter contrast-[1.05]"
                  ></iframe>

                  {/* Overlapping Badge Pill on Top of Map */}
                  <div className="absolute top-4 left-4 right-4 bg-white/90 backdrop-blur-md p-3.5 rounded-xl border border-gold-300 shadow-lg flex items-center justify-between pointer-events-auto">
                    <div className="flex items-center gap-2.5">
                      <div className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-ping"></div>
                      <span className="text-xs font-bold text-[#0b3a24] font-sans">Chirayil Gold & Diamonds</span>
                    </div>
                    <span className="text-[9px] font-bold text-[#0b3a24]/70 bg-gold-200/50 px-2.5 py-1 rounded-md uppercase tracking-wider font-sans">Pulpally</span>
                  </div>
                </div>

              </div>
            </div>

          </div>

          {/* Collapsible Full Drawer Option */}
          <div className={`overflow-hidden transition-all duration-500 ease-in-out ${showMap ? "max-h-[500px] opacity-100 mt-10" : "max-h-0 opacity-0 mt-0"}`}>
            <div className="relative w-full h-[450px] rounded-3xl overflow-hidden shadow-2xl border-2 border-[#eddca6] bg-luxury-cream">
              <iframe
                title="Chirayil Gold and Diamonds Full Google Map"
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d3904.7019517216722!2d76.1503030750581!3d11.85612398836603!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1734508758906!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

        </div>
      </section>

      {/* Map & Contact section */}
      <section className="bg-[#fafaf7]/20 py-28 px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-7xl mx-auto">
          
          <div className="text-center mb-16 space-y-4">
            <p className="text-xs font-bold text-[#0b3a24] tracking-[0.25em] uppercase font-sans">LOCATION & ASSISTANCE</p>
            <h2 className="text-4xl sm:text-5xl font-serif font-black text-[#0b3a24]">
              Need Help? <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0b3a24] via-[#c5a85a] to-[#0b3a24] font-bold font-serif">Contact Us</span>
            </h2>
            <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-gold-500/30 to-transparent mx-auto"></div>
          </div>

          <div className="grid lg:grid-cols-3 gap-16">
            
            {/* Contact Details Column */}
            <div className="lg:col-span-1 space-y-6">
              
              {/* Address */}
              <div className="bg-white rounded-2xl p-6 flex items-start gap-5 border border-gold-300 hover:border-[#0b3a24]/30 transition-all duration-300 shadow-sm">
                <div className="w-12 h-12 bg-[#fafaf7] border border-gold-300 rounded-xl flex items-center justify-center flex-shrink-0 shadow-sm">
                  <MapPin className="w-5 h-5 text-[#0b3a24]" />
                </div>
                <div className="space-y-1">
                  <h3 className="font-bold text-[#0b3a24]">Our Showroom</h3>
                  <p className="text-xs text-[#0b3a24]/60 leading-relaxed font-light">
                    PERIKALLUR Road, Pulpally, Wayanad, Kerala, 673579
                  </p>
                </div>
              </div>

              {/* Call Us */}
              <div className="bg-white rounded-2xl p-6 flex items-start gap-5 border border-gold-300 hover:border-[#0b3a24]/30 transition-all duration-300 shadow-sm">
                <div className="w-12 h-12 bg-[#fafaf7] border border-gold-300 rounded-xl flex items-center justify-center flex-shrink-0 shadow-sm">
                  <Phone className="w-5 h-5 text-[#0b3a24]" />
                </div>
                <div className="space-y-1">
                  <h3 className="font-bold text-[#0b3a24]">Call Us</h3>
                  <p className="text-xs text-[#0b3a24]/60 leading-relaxed font-light">
                    +91 9605155088<br />
                    +91 6282370250
                  </p>
                </div>
              </div>

              {/* Email Us */}
              <div className="bg-white rounded-2xl p-6 flex items-start gap-5 border border-gold-300 hover:border-[#0b3a24]/30 transition-all duration-300 shadow-sm">
                <div className="w-12 h-12 bg-[#fafaf7] border border-gold-300 rounded-xl flex items-center justify-center flex-shrink-0 shadow-sm">
                  <Mail className="w-5 h-5 text-[#0b3a24]" />
                </div>
                <div className="space-y-1">
                  <h3 className="font-bold text-[#0b3a24]">Email Support</h3>
                  <p className="text-xs text-[#0b3a24]/60 leading-relaxed font-light font-sans">
                    info@chirayilgoldanddiamonds.com
                  </p>
                </div>
              </div>

              {/* Opening Hours */}
              <div className="bg-white rounded-2xl p-6 flex items-start gap-5 border border-gold-300 hover:border-[#0b3a24]/30 transition-all duration-300 shadow-sm">
                <div className="w-12 h-12 bg-[#fafaf7] border border-gold-300 rounded-xl flex items-center justify-center flex-shrink-0 shadow-sm">
                  <Clock className="w-5 h-5 text-[#0b3a24]" />
                </div>
                <div className="space-y-1">
                  <h3 className="font-bold text-[#0b3a24]">Opening Hours</h3>
                  <p className="text-xs text-[#0b3a24]/60 leading-relaxed font-light">
                    Monday - Sunday: 10:00 AM - 08:00 PM
                  </p>
                </div>
              </div>

            </div>

            {/* Contact Form Column */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-3xl p-8 sm:p-10 border border-gold-300 shadow-xl">
                <h3 className="text-2xl font-serif font-bold text-[#0b3a24] mb-8">Send An Inquiry</h3>
                <div className="space-y-8">
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div className="relative group">
                      <input
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleInputChange}
                        className="w-full px-5 py-4 bg-[#fafaf7]/30 border-b border-gold-300 focus:border-[#0b3a24] focus:outline-none placeholder-[#0b3a24]/40 text-xs font-semibold text-[#0b3a24] transition-all duration-300 focus:bg-white"
                      />
                    </div>
                    <div className="relative group">
                      <input
                        type="email"
                        name="email"
                        placeholder="Your Email Address"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="w-full px-5 py-4 bg-[#fafaf7]/30 border-b border-gold-300 focus:border-[#0b3a24] focus:outline-none placeholder-[#0b3a24]/40 text-[#0b3a24] transition-all duration-300 focus:bg-white"
                      />
                    </div>
                  </div>

                  <div className="relative group">
                    <input
                      type="text"
                      name="subject"
                      placeholder="Subject of Interest"
                      value={formData.subject}
                      onChange={handleInputChange}
                      className="w-full px-5 py-4 bg-[#fafaf7]/30 border-b border-gold-300 focus:border-[#0b3a24] focus:outline-none placeholder-[#0b3a24]/40 text-xs font-semibold text-[#0b3a24] transition-all duration-300 focus:bg-white"
                    />
                  </div>

                  <div className="relative group">
                    <textarea
                      name="message"
                      placeholder="Describe how we can assist you..."
                      rows={4}
                      value={formData.message}
                      onChange={handleInputChange}
                      className="w-full px-5 py-4 bg-[#fafaf7]/30 border-b border-gold-300 focus:border-[#0b3a24] focus:outline-none placeholder-[#0b3a24]/40 text-[#0b3a24] transition-all duration-300 focus:bg-[#fafaf7] resize-none"
                    />
                  </div>

                  <div className="text-right">
                    <button
                      type="button"
                      onClick={handleSubmit}
                      className="bg-gradient-to-r from-[#0b3a24] to-[#0e482d] text-white font-bold px-10 py-4 rounded-xl text-xs uppercase tracking-widest hover:shadow-xl hover:scale-[1.01] active:scale-[0.99] transition-all duration-300 font-sans"
                    >
                      Send Message
                    </button>
                  </div>

                </div>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Floating Scroll to Top button */}
      <div className="fixed bottom-8 right-8 z-50">
        <button 
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="w-12 h-12 bg-gradient-to-br from-[#0b3a24] to-[#0e482d] text-white rounded-full flex items-center justify-center shadow-xl hover:scale-110 active:scale-90 transition-all duration-300 group border border-gold-300/40"
          aria-label="Scroll to top"
        >
          <svg className="w-5 h-5 transform group-hover:-translate-y-0.5 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 15l7-7 7 7" />
          </svg>
        </button>
      </div>

    </div>
  );
}